import type { ChangeContext, Options } from '@angular-slider/ngx-slider';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@Component({
    selector: 'sp-slider',
    templateUrl: './sp-slider.component.html',
    styleUrls: ['./sp-slider.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, NgxSliderModule],
})
export class SpSliderComponent {
    @Input() public value: number = 0;
    @Input() public highValue: number = 0;
    @Input() public sliderType: 'default' | 'range' = 'default';
    @Input() set options(options: Options) {
        this._options = { ...this._options, ...options };
    }
    get options(): Options {
        return this._options;
    }

    @Output() public valueChangeEvent: EventEmitter<ChangeContext> = new EventEmitter<ChangeContext>();
    @Output() public highValueChangeEvent: EventEmitter<ChangeContext> = new EventEmitter<ChangeContext>();

    private _options: Options = {
        floor: 0,
        minLimit: 5,
        step: 5,
        ceil: 100,
        showSelectionBar: true,
    };

    public change(event: any): any {
        this.value = event;
        this.valueChangeEvent.emit(event);
    }

    public highValueChange(event: any): any {
        this.highValue = event;
        this.highValueChangeEvent.emit(event);
    }
}
